import { Component, OnDestroy, OnInit } from '@angular/core';
import { Constants } from 'src/app/constants';
import { AlarmsService } from 'src/app/service/alarms.service';
import { UserService } from 'src/app/service/user.service';
import { environment } from "../../../environments/environment";
import { FGAData } from 'src/app/fga/models';
import { Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { VersionCheckService } from 'src/app/service/cache.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false // NOSONAR
})
export class HeaderComponent implements OnInit, OnDestroy {

  constants: Constants = new Constants()
  navlinks = this.constants.navLinkItems;
  userName: any = '';
  getRole = { "name": "", "user_role": "", "role_1": '', "role_2": '' };
  rolesArray = [];
  userInfo: any;
  myGUID: string = '45C278ACB1424F448C96D6F55684D72A';
  guid: string = '';
  fgaDetails: FGAData | null = null;
  private subscription: Subscription;
  highlightHome = false;
  selected = new FormControl();
  currentIndex: any = 0;

  constructor(private readonly alarmsService: AlarmsService, private readonly userService: UserService, private readonly versionCheckService: VersionCheckService) { }

  ngOnInit(): void {
    this.selected.setValue(1);
    this.toggler('planning');
    this.subscription = this.userService.getDetails().subscribe(details => {
      this.fgaDetails = details;
      console.info('[Header] FGA details received:', details);
      if (this.fgaDetails) {
        this.userName = localStorage.getItem('name');
        const userName_ = this.fgaDetails?.user?.firstName + ' ' + this.fgaDetails?.user?.lastName;
				this.getRole.name = userName_;
        this.getRole.user_role = 'Admin';
        let roles = []
        this.rolesArray = [];
        roles = this.fgaDetails?.roles
        if (roles?.length) {
          roles.forEach(e => {
            this.rolesArray.push(e.displayName)
          })
        }
      }
    });
    this.versionCheckService.initVersionCheck();
  }

  logout() {
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace(environment.liosUrl);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onTabClick(index: number) {
    localStorage.setItem('currentIndex', index.toString());
  }

  navigate(url: any) {
    const _url = environment.liosUrl + url;
    console.info("_url_ ", _url)
    // this.router.navigateByUrl(_url);
    window.location.href = _url;
  }

  navigateExternalUrl(url: any) {
    window.location.href = url;
  }

  navigateExternalUrlNewWin(url: any) {
    window.open(url);
  }

  toggler(pageHeader: string): void {
    if (
      pageHeader.includes('home') ||
      pageHeader === '' ||
      pageHeader === '#'
    ) {
      this.highlightHome = true;
    } else {
      this.highlightHome = false;
    }
  }
}